/* eslint-disable */
import html2canvas from 'html2canvas';
import JsPDF from 'jspdf';
/**
 * @param  ele          要生成 pdf 的DOM元素（容器）
 * @param  type     0：生成多个ele；1：一个ele切割成多个img
 * */
async function downloadPDF(ele, type) {//大于二十页用用循环，小于二十页用切割
  var pdf = new JsPDF('l', 'pt', 'a4');//第一个参数表示横向或者纵向l横向，p纵向
  if (type === 0) {
    for (let i = 0; i < ele.length; i++) {
      console.log(ele[i])
      await html2canvas(ele[i], {
        scale: 2,
        dpi: 300,
        width:  1122.52,
        height:793.69,
        // allowTaint: true,  //允许 canvas 污染， allowTaint参数要去掉，否则是无法通过toDataURL导出canvas数据的
        useCORS: true,  //允许canvas画布内 可以跨域请求外部链接图片, 允许跨域请求。
        scrollY: 0, // 纵向偏移量 写死0 可以避免滚动造成偶尔偏移的现象
      }).then((canvas) => {
        var contentWidth = canvas.width;
        var contentHeight = canvas.height;
        console.log(contentWidth, contentHeight)
        //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
        var imgWidth = 841.89;
        var imgHeight = 841.89 / contentWidth * contentHeight;
        var pageData = canvas.toDataURL('image/jpeg', 0.5);
        //有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
        //当内容未超过pdf一页显示的范围，无需分页
        pdf.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight);
        if (ele[i + 1]) {
          pdf.addPage()
        }
      })
    }
    //可动态生成
    // pdf.save(pdfName);
    window.open(pdf.output('bloburl'));
  }
  else {
    await html2canvas(ele, {
      scale: 2,
      dpi: 300,
      // allowTaint: true,  //允许 canvas 污染， allowTaint参数要去掉，否则是无法通过toDataURL导出canvas数据的
      useCORS: true,  //允许canvas画布内 可以跨域请求外部链接图片, 允许跨域请求。
      scrollY: 0, // 纵向偏移量 写死0 可以避免滚动造成偶尔偏移的现象
    }).then((canvas) => {
      //A4纸对应html297*210mm
      var contentWidth = canvas.width;
      var contentHeight = canvas.height;
      //一页pdf显示html页面生成的canvas高度;
      // var pageHeight = contentWidth / 841.89 * 592.28;
      var pageHeight = 1588;
      //未生成pdf的html页面高度
      var leftHeight = contentHeight;
      //打印页面的页面偏移
      var position = 0;
      //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
      var imgWidth = 841.89;
      var imgHeight = 841.89 / contentWidth * contentHeight;
      var pageData = canvas.toDataURL('image/jpeg', 0.5);
      //有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
      //当内容未超过pdf一页显示的范围，无需分页
      if (leftHeight < pageHeight) {
        //在pdf.addImage(pageData, 'JPEG', 左，上，宽度，高度)设置在pdf中显示；
        pdf.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight);
        // pdf.addImage(pageData, 'JPEG', 0, 20, imgWidth, imgHeight);
      } else {    // 分页
        while (leftHeight > 0) {
          pdf.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight);
          leftHeight -= pageHeight;
          position -= 595.28;
          //避免添加空白页
          if (leftHeight > 0) {
            pdf.addPage();
          }
        }
      }
      //可动态生成
      // pdf.save(pdfName);
      window.open(pdf.output('bloburl'));
    })
  }
}
export default downloadPDF;